import React from 'react'
import { Row } from 'react-bootstrap'

const Notification = (props) => {

  const { name, is_read, is_pinned, url } = props.notification

  const handleContextMenu = (e) => {
    e.preventDefault()
  }

  const handleClick = (e) => {
    if (e.target.className === 'remove-button') {
      return
    }
    /// CSS THAT HANDLES NOTIFICATION SELECTION
    let readNotifications = document.querySelectorAll('.notification-name-read')
    let unreadNotifications = document.querySelectorAll('.notification-name-unread')
    let allNotifications = [...readNotifications, ...unreadNotifications]

    allNotifications.forEach(notification => {
      notification.className = notification.className.replace(" active", "")
    })

    if (!is_read) {
      e.target.className = "notification-name-read"
    }
    e.target.className += " active"

    props.selectNotification(props.notification)
  }

  return (
    <Row className="notification" onClick={handleClick}>
      <div className={`notification-name-${is_read && !is_pinned ? 'read' : 'unread'}`}
           onContextMenu={ handleContextMenu }>
        { is_pinned ?
          <span id="notification-icon" title="Pinned" />
          : null
        }
        { name }
        <span
          className='remove-button'
          onClick={ () => props.deleteNotification(url) } 
        >
        remove
        </span>
      </div>
    </Row>
  )

}

export default Notification;



// WEBPACK FOOTER //
// ./src/routes/notifications/components/Notification.js